import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-port-opt',
  templateUrl: './port-opt.component.html',
  styleUrl: './port-opt.component.css'
})
export class PortOptComponent {
@Input() option:any;
}
